<template>
  <div>
    <transition name="fade">
      <div v-if="$parent.details" class="popup">
        <div @click="$parent.details = null" class="offclick"></div>
        <div class="holder">
          <p @click="$parent.details = null" class="close">x</p>
          <transition name="fade-quick">
            <div>
              <p class="title">{{ kiosk.name }}</p>
              <p class="sku">{{ kiosk.sku }}</p>
              <p class="desc">{{ kiosk.description }}</p>
              <div class="kiosk-imgs">
                <img v-if="kiosk.img" :src="kiosk.img" />
                <img
                  v-else-if="kiosk.images"
                  v-for="img in kiosk.images"
                  :src="img"
                  :key="img"
                />
                <img
                  v-else
                  v-for="(img, index) in imgs"
                  :src="img"
                  :key="index"
                />
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
const functions = fb.default.functions;

export default {
  name: "kiosk-popup",
  props: ["kiosk"],
  data() {
    return {
      imgs: [
        "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/original.png?alt=media&token=e434d19b-c510-4374-8365-ee9c8e040c5f",
        "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/original.png?alt=media&token=e434d19b-c510-4374-8365-ee9c8e040c5f",
        "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/original.png?alt=media&token=e434d19b-c510-4374-8365-ee9c8e040c5f",
        "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/original.png?alt=media&token=e434d19b-c510-4374-8365-ee9c8e040c5f",
      ],
    };
  },
  methods: {},
};
</script>

<style scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 199;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(53, 73, 94, 0.75);
}

.login-loader {
  height: 50px;
  display: block;
  width: auto !important;
}

.title {
  font-size: 30px;
  font-weight: bold;
  font-family: "SFProDisplay", sans-serif;
  margin-top: 0;
}

.offclick {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  height: 100%;
  width: 100%;
}

.holder {
  position: relative;
  z-index: 2;
  padding: 50px;
  width: 500px;
  background-color: white;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  max-height: 600px;
  overflow: auto;
}

.not_found .holder {
  max-height: 100%;
  overflow: auto;
}

.holder input {
  width: 100%;
  box-sizing: border-box;
}

.holder .txt_btn {
  font-size: 23px;
}

.thanks {
  text-align: center;
}

.loader {
  width: 200px !important;
  margin: auto;
}

.holder {
  padding: 50px;
}

.holder p {
  line-height: 1.2;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade_delay-enter-active,
.fade_delay-leave-active {
  transition: opacity 0.5s;
  transition-delay: 0.5s;
}
.fade_delay-enter, .fade_delay-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.close {
  font-size: 25px;
  font-weight: bold;
  opacity: 0.4;
  padding: 10px 20px;
  margin: 0;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.btns {
  width: 100%;
}

.error {
  text-align: left;
}

.sku {
  color: #49c6d4;
  margin-top: -20px;
  font-weight: bold;
}

.desc {
  margin-top: 30px;
}

.kiosk-imgs {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.kiosk-imgs img {
  width: 49%;
  margin-bottom: 10px;
}

@media screen and (max-width: 700px) {
  .kiosk-imgs img {
    width: 100%;
  }
}
</style>
